// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2iR2f"};